import { Component, inject } from '@angular/core'
import { FormBuilder, Validators, type FormGroup } from '@angular/forms'
import $uploadNewRecoBuyQty from '../../../05_ag-grid-configs/01_json-grid-configs/reco-buy-qty/colDefs-reco-buy-qty-upload.json'
import { GeneralAPIs } from 'src/app/core/apis/general_api-calls'
import { type GridFileUploadInterface } from 'src/app/core/interfaces/grid-file-upload-interface'
import { GridFileUploadService } from 'src/app/core/services/grid-file-upload-service.service'
import { DynamicDialogRef } from 'primeng/dynamicdialog'
import { CustomGridOptions } from 'src/app/05_ag-grid-configs/02_global-settings/grid-options'
import { SizeDistroManagementSummaryAPIs } from 'src/app/core/apis/size-distro-management-summary_api-calls'
import { RecoBuyQtyAPIs } from 'src/app/core/apis/reco-buy-qty_api-calls'

@Component({
  standalone: false,
  selector: 'app-reco-buy-qty-modal',
  templateUrl: './reco-buy-qty-modal.component.html',
  styleUrls: ['./reco-buy-qty-modal.component.scss']
})
export class RecoBuyQtyUploadModalComponent {
  public uploadNewRecoBuyQty = $uploadNewRecoBuyQty
  private readonly _formBuilder = inject(FormBuilder)
  modalTitle = 'Upload Assortment Plan'
  loading = true
  processingData = false
  canSubmitGridData = false
  loadingMessage = ''

  fileData: string[][]

  totalSize: number = 0
  totalSizePercent: number = 0

  detailsFormGroup: FormGroup
  buyingSeasonOptions = [
    'Fall 2020',
    'Spring 2021',
    'Fall 2021',
    'Spring 2022',
    'Fall 2022',
    'Spring 2023',
    'Fall 2023',
    'Spring 2024',
    'Fall 2024',
    'Spring 2025',
    'Fall 2025',
    'Spring 2026',
    'Fall 2026'
  ]

  prodFields = ['div_id', 'dept_id', 'class_id']
  positiveNumberFields = ['moq', 'ecomm_tgt_qty', 'stores_tgt_qty']
  nonNegativeNumberFields = ['retail_cost_($)', 'retail_price_($)']
  requiredPairs = [
    ['attr_1', 'value_1'],
    ['attr_2', 'value_2'],
    ['attr_3', 'value_3']
  ]

  requiredPairsDirectional = [
    ['ecomm_tgt_qty', 'ecomm_size_range'],
    ['stores_tgt_qty', 'stores_size_range']
  ]

  requiredORPairs = [['ecomm_size_range', 'stores_size_range']]

  templateDownloadMessage = '** See app page for rules **'

  gridOptions = {
    ...CustomGridOptions,
    defaultColDef: {
      autoHeaderHeight: true,
      wrapHeaderText: true
    }
  }

  gridDetails: {
    ['Reco Buy Qty Upload Data']: GridFileUploadInterface
  } = {
      'Reco Buy Qty Upload Data': null
    }

  checkExistingAPIFunc = null

  constructor (
    readonly generalAPIs: GeneralAPIs,
    private readonly gridFileUploadService: GridFileUploadService,
    public readonly dynamicDialogRef: DynamicDialogRef,
    private readonly recoBuyQtyApi: RecoBuyQtyAPIs
  ) {
    this.checkExistingAPIFunc = async data => {
      console.log('checking data', data)
      return await this.generalAPIs.CheckProdIdDuplicates(data)
    }

    this.recoBuyQtyApi.getSeasons().subscribe(data => {
      console.log('Seasons: ', data)
      this.buyingSeasonOptions = data
    })
    this.gridFileUploadService.getRowDataUpdates().subscribe((res: GridFileUploadInterface) => {
      if (res) {
        console.log('grid file upload service res', res)
        this.gridDetails[res.gridTitle] = res
        if (this.gridDetails['Reco Buy Qty Upload Data']?.rowDataIncomplete) {
          this.canSubmitGridData = false
        } else {
          this.canSubmitGridData = true
        }
        this.fileData = res.rowData
      }
    })
    this.detailsFormGroup = this._formBuilder.group({
      planNameControl: ['', Validators.required],
      buyingSeasonControl: ['', Validators.required],
      maxPlanRetailCostControl: ['', Validators.required],
      runAfterSaveControl: ['']
    })
    this.loading = false
  }

  onSaveToRepository () {
    this.dynamicDialogRef.close({
      fileData: this.fileData,
      formData: this.detailsFormGroup.value
    })
  }
}
